// @flow
import { types as t } from '../validation/runtime-checks/index.js';
import { Text } from '../Text.js';
import Latex from '../Latex.js';
import { LatexTextAtom } from '../LatexTextAtom.js';
import Image from '../Image.js';
import BoxAndWhiskerPlot from '../BoxAndWhiskerPlot.js';
import { CartesianPlane } from '../CartesianPlane.js';
import { NumberLine } from '../NumberLine.js';
import { StemAndLeafPlot } from '../StemAndLeafPlot.js';
import TabularData from '../TabularData.js';
import { TwoColumnProof } from '../TwoColumnProof.js';
import { AlgebraicWorking } from '../AlgebraicWorking.js';
import DraftImage from '../DraftImage.js';
import { PseudoCodeBlock } from '../PseudoCodeBlock.js';

export type SharedSubstantativeChildren =
  | React$Element<typeof Text>
  | React$Element<typeof Latex>
  | React$Element<typeof LatexTextAtom>
  | React$Element<typeof Image>
  | React$Element<typeof DraftImage>
  // probably only need those above this line
  | React$Element<typeof BoxAndWhiskerPlot>
  | React$Element<typeof CartesianPlane>
  | React$Element<typeof NumberLine>
  | React$Element<typeof StemAndLeafPlot>
  | React$Element<typeof TabularData>
  | React$Element<typeof TwoColumnProof>
  | React$Element<typeof AlgebraicWorking>
  | React$Element<typeof PseudoCodeBlock>;

export const sharedSubstantativeChildrenChecker = t.unionOfTypes(
  t.elementType(Text),
  t.elementType(Latex),
  t.elementType(LatexTextAtom),
  t.elementType(Image),
  t.elementType(DraftImage),
  // probably only need those above this line
  t.elementType(BoxAndWhiskerPlot),
  t.elementType(CartesianPlane),
  t.elementType(NumberLine),
  t.elementType(StemAndLeafPlot),
  t.elementType(TabularData),
  t.elementType(TwoColumnProof),
  t.elementType(AlgebraicWorking),
  t.elementType(PseudoCodeBlock),
);
